<template>
  <div
    class="promo-material position-relative d-flex justify-content-between rounded border p-5 py-3 m-0"
  >
    <div>
      <h6 class="mb-0">{{ title }}</h6>
      <small class="text-secondary">{{ description }}</small>
    </div>
    <button class="btn text-primary">Ver</button>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: () => ""
    },
    description: {
      type: String,
      default: () => ""
    },
    actionBtn: {
      type: String,
      default: () => ""
    }
  }
};
</script>
